module.exports = __webpack_public_path__ + "img/csv.a20a15a6.svg";